import { NgModule } from "@angular/core";
import { PastePageSectionModalComponent } from "../../components/paste-page-section-modal/paste-page-section-modal.component";
import { CommonModule } from "@angular/common";

@NgModule({
    exports: [PastePageSectionModalComponent],
    declarations: [PastePageSectionModalComponent],
    imports: [CommonModule]
})
export class PastePageSectionModalModule {}
